import React from "react";
import { Modal, Input, Form } from "antd";

export const InterestDlg = ({
  open,
  saving,
  save,
  close,
  check,
}: {
  open: boolean;
  saving: boolean;
  save: (values: any) => Promise<void>;
  close: () => void;
  check: (groupName: string, name: string) => Promise<string>;
}) => {
  const [form] = Form.useForm();

  const onSave = () => {
    form.validateFields().then((values) => save(values));
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title="Interest"
      visible={open}
      onOk={onSave}
      maskClosable={false}
      confirmLoading={saving}
      onCancel={() => close()}
    >
      <Form form={form} {...layout} initialValues={{}}>
        <Form.Item
          label="Group Name"
          name="groupName"
          rules={[{ required: true, message: "Please input group name!" }]}
        >
          <Input placeholder="Enter group name" />
        </Form.Item>
        <Form.Item
          shouldUpdate
          label="Name"
          name="name"
          validateTrigger={["onBlur", "onChange"]}
          hasFeedback
          rules={[
            { required: true, message: "Please input name!" },
            ({ getFieldValue }) => ({
              validateTrigger: "onBlur",
              validator(_, value) {
                const groupName = getFieldValue("groupName");
                if (!value || !groupName) return Promise.resolve();
                return check(groupName, value).then((msg) => {
                  if (msg) return Promise.reject(new Error(msg));
                  return Promise.resolve();
                });
              },
            }),
          ]}
        >
          <Input placeholder="Enter name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
